"use strict";

exports.__esModule = true;
exports.getAPR = getAPR;
var _sdkCore = require("@acala-network/sdk-core");
var _constants = require("../../utils/constants");
/**
 * @name getAPR
 * @param collateral the pool collateral
 * @param accumulatePeriod reward accumulate period
 * @param prices prices of all required tokens
 * @param share total share of the pool
 * @param deductionRate deduction rate of the pool
 * @param rewardConfigs reward configs of the pool
 */
function getAPR(collateral, accumulatePeriod, prices, share, deductionRate, rewardConfigs) {
  const collateralPrice = prices[collateral.name];
  const totalDeposited = share.mul(collateralPrice);
  const periodCount = _constants.MILLISECONDS_OF_YEAR / _constants.EXPECTED_BLOCK_TIME / accumulatePeriod;
  const totalRewardOnePeriod = rewardConfigs.reduce((acc, cur) => {
    if (cur.amount && !cur.amount.isZero()) {
      return acc.plus(cur.amount.times(prices[(0, _sdkCore.forceToCurrencyName)(cur.token)] || _sdkCore.FixedPointNumber.ZERO));
    }
    return acc;
  }, _sdkCore.FixedPointNumber.ZERO);
  const totalRewardOnePeriodWithDeduction = totalRewardOnePeriod.times(_sdkCore.FixedPointNumber.ONE.minus(deductionRate));
  const apr = totalRewardOnePeriod.div(totalDeposited).times(new _sdkCore.FixedPointNumber(periodCount));
  const aprWithDeduction = totalRewardOnePeriodWithDeduction.div(totalDeposited).times(new _sdkCore.FixedPointNumber(periodCount));
  const rateOnePeriod = totalRewardOnePeriod.div(totalDeposited);
  const apy = Math.pow(Number(rateOnePeriod.toString()) + 1, periodCount) - 1;
  return {
    apr: apr.toNumber(),
    aprWithDeduction: aprWithDeduction.toNumber(),
    apy
  };
}